import React from "react";
import { Checkbox } from "../../../common";
import "./DetailedCheckbox.scss";

const DetailedCheckbox = ({ label, details, ...rest }) => (
  <div className="DetailedCheckbox">
    {/* eslint-disable-next-line jsx-a11y/label-has-for */}
    <label className="label" htmlFor={rest.id}>
      <Checkbox className="label__checkbox" label="" {...rest} />
      <div className="label__details-container">
        <p className="label__title">{label}</p>
        <p className="label__details">{details}</p>
      </div>
    </label>
  </div>
);

export default DetailedCheckbox;
